import { Button as AntButton, DatePicker, Dropdown, Flex, Input } from 'antd';
import type { MenuProps } from 'antd';
import {
  DownOutlined,
  FilterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { Dayjs } from 'dayjs';
import type { AssetLogsFilters } from '~/app/hooks/assets/useAssetLogs';

type Props = {
  filters: AssetLogsFilters;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onFiltersChange: (filters: AssetLogsFilters) => void;
  onReset: () => void;
  dateRangeValue: [Dayjs, Dayjs] | null;
};

export function AssetLogsTableToolbar({
  filters,
  searchValue,
  onSearchChange,
  onFiltersChange,
  onReset,
  dateRangeValue,
}: Props) {
  const { t } = useTranslation('assets');

  const isTreatedValue =
    filters.isTreated === true
      ? 'true'
      : filters.isTreated === false
        ? 'false'
        : 'all';

  const statusMenuItems: MenuProps['items'] = [
    { key: 'all', label: t('filters.all') },
    { key: 'true', label: t('filters.treated') },
    { key: 'false', label: t('filters.untreated') },
  ];

  const statusLabel =
    isTreatedValue === 'all'
      ? t('filters.all')
      : isTreatedValue === 'true'
        ? t('filters.treated')
        : t('filters.untreated');

  return (
    <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
      <Flex gap={12} wrap="wrap" justify="flex-start" align="center">
        <DatePicker.RangePicker
          showTime
          format="YYYY-MM-DD HH:mm"
          value={dateRangeValue}
          onChange={(dates) => {
            onFiltersChange({
              ...filters,
              from: dates?.[0]?.toISOString() ?? undefined,
              to: dates?.[1]?.toISOString() ?? undefined,
            });
          }}
          placeholder={[t('filters.from'), t('filters.to')]}
          style={{ borderRadius: 8 }}
        />
        <Dropdown
          trigger={['click']}
          menu={{
            items: statusMenuItems,
            onClick: ({ key }) => {
              onFiltersChange({
                ...filters,
                isTreated: key === 'all' ? undefined : key === 'true',
              });
            },
            selectedKeys: [isTreatedValue],
          }}
        >
          <AntButton
            type="text"
            icon={<FilterOutlined />}
            style={{ fontSize: 13 }}
          >
            {statusLabel}
            <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
          </AntButton>
        </Dropdown>
        <Input
          allowClear
          placeholder={t('filters.search')}
          prefix={<SearchOutlined />}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: 240, borderRadius: 8 }}
        />
        <AntButton onClick={onReset}>{t('filters.reset')}</AntButton>
      </Flex>
    </Flex>
  );
}
